import React, { useMemo } from 'react';
import SpaceWindowsTable from './SpaceWindowsTable';
import { useData } from '../../../../hooks/useData';
import { useApp } from '../../../../contexts/AppContext';
import { useErrorLogging, ERROR_SEVERITY, ERROR_CATEGORY } from '../../../../utils/errorLogging';
import { TABLES } from '../../../../constants';

function SpaceWindowsSection({ spaceId, spaceData }) {
  const { currentProject } = useApp();
  const { logError } = useErrorLogging();

  // Fetch project windows
  const {
    data: projectWindows,
    error: projectWindowsError,
    isLoading: projectWindowsLoading,
  } = useData(TABLES.PROJECT_WINDOWS, {
    enabled: Boolean(currentProject?.id && spaceId),
    select: '*',
    filter: { space_id: spaceId },
    realtime: true,
    onError: error => {
      logError(error, {
        severity: ERROR_SEVERITY.ERROR,
        category: ERROR_CATEGORY.DATA_FETCH,
        message: 'Error fetching project windows',
      });
    },
  });

  // Fetch project_items tagged with window_id (for cost, profile, shading info)
  const { data: windowLinkedItems } = useData(TABLES.PROJECT_ITEMS, {
    enabled: Boolean(currentProject?.id && spaceId),
    select: 'id, master_item_id, total_cost, selected_option, details',
    filter: { space_id: spaceId },
    realtime: true,
  });

  // Index window-linked items by window_id
  const windowItemsMap = useMemo(() => {
    if (!windowLinkedItems) return {};
    const map = {};
    windowLinkedItems.forEach(item => {
      const windowId = item.details?.window_id;
      if (windowId) {
        if (!map[windowId]) map[windowId] = [];
        map[windowId].push(item);
      }
    });
    return map;
  }, [windowLinkedItems]);

  if (projectWindowsError) {
    return <div>שגיאה בטעינת הנתונים</div>;
  }

  if (projectWindowsLoading || !spaceData) {
    return <div>Loading...</div>;
  }

  return (
    <SpaceWindowsTable
      projectWindows={projectWindows}
      windowItemsMap={windowItemsMap}
      space={spaceData}
    />
  );
}

export default SpaceWindowsSection;
